/**
 * Header compartido para overlays a pantalla completa (formularios, detalle,
 * vista dividida, picker). Única fuente de verdad del markup `aplic-form-header`.
 * El botón atrás siempre es `.aplic-form-back-btn` (quien lo use cablea su onclick).
 */
export function renderFormHeader(opts: { title?: string; subtitle?: string }): string {
  return `
    <div class="aplic-form-header">
      <button class="aplic-form-back-btn" title="Volver"><i class="ph ph-arrow-left" aria-hidden="true"></i></button>
      <div class="aplic-form-header-info">
        ${opts.title ? `<span class="aplic-form-header-title">${opts.title}</span>` : ""}
        ${opts.subtitle ? `<span class="aplic-form-header-sub">${opts.subtitle}</span>` : ""}
      </div>
    </div>
  `;
}
